import { NgIf, NgStyle } from '@angular/common';
import { Component, HostBinding, Injector } from '@angular/core';

import { CasinoCoreGamelaunchService, CasinoManager, GameLaunch, GameManagerService } from '@casinocore/platform/core';
import { TrackingService } from '@frontend/vanilla/core';
import { PCComponent } from '@frontend/vanilla/features/content';

import { InstagramStoryModalComponent } from '../instagram-story-modal/instagram-story-modal.component';
import { PromoOptinButtonComponent } from '../promo-optin-button/promo-optin-button.component';

@Component({
    selector: 'cc-insta-story-imagery-item',
    templateUrl: 'insta-story-imagery-item.component.html',
    imports: [NgIf, NgStyle, PromoOptinButtonComponent],
})
export class InstaStoryImageryItemComponent extends PCComponent {
    instaStoryImageryItem: any;
    optinCta: any;
    optinBtnTxt: string;
    isDisplayCta: boolean;
    isEnableCustomCta: boolean;
    TitleTxtClr: string;
    SubTitleTxtClr: string;
    DescriptionClr: string;
    OptinBtnBgClr: string;
    OptinBtnTxtClr: string;
    TncTxtClr: string;
    TncBgClr: string;
    TitleFontSize: string;
    SubTitleFontSize: string;
    ctaText: string;
    gameId: string;
    gamingCtaText: string;
    @HostBinding()
    get class() {
        this.instaStoryImageryItem = this.item;
        this.optinBtnTxt = this.instaStoryImageryItem.parameters.OptinBtn;
        this.isDisplayCta = this.instaStoryImageryItem.displayCTA;
        this.isEnableCustomCta = this.instaStoryImageryItem.enableCustomCTA;
        this.TitleTxtClr = this.instaStoryImageryItem.keys.TitleTxtClr;
        this.SubTitleTxtClr = this.instaStoryImageryItem.keys.SubTitleTxtClr;
        this.DescriptionClr = this.instaStoryImageryItem.keys.DescriptionClr;
        this.OptinBtnBgClr = this.instaStoryImageryItem.keys.OptinBtnBgClr;
        this.OptinBtnTxtClr = this.instaStoryImageryItem.keys.OptinBtnTxtClr;
        this.TncTxtClr = this.instaStoryImageryItem.keys.TncTxtClr;
        this.TncBgClr = this.instaStoryImageryItem.keys.TncBgClr;
        this.TitleFontSize = this.instaStoryImageryItem.keys.TitleFontSize;
        this.SubTitleFontSize = this.instaStoryImageryItem.SubTitleFontSize;
        this.gameId = this.instaStoryImageryItem.gameID;
        this.gamingCtaText = this.instaStoryImageryItem.keys.GamingCtaText;
        if (this.instaStoryImageryItem.customCTA) {
            this.optinCta = this.instaStoryImageryItem.customCTA.url;
            this.ctaText = this.instaStoryImageryItem.customCTA.text;
        }
        return this.createClass(this.item.name);
    }

    constructor(
        private tracking: TrackingService,
        private casinoManager: CasinoManager,
        private gameLaunchService: CasinoCoreGamelaunchService,
        public injector: Injector,
        private gameManagerService: GameManagerService,
    ) {
        super();
    }

    optinClick() {
        const storyComponent = this.injector.get(InstagramStoryModalComponent);
        const activePromoName = storyComponent.activePromo.promoItemId;
        const activePromoStoryName = storyComponent.activePromo.instaStoryContentModel[storyComponent.activePromoStoryIndex].mainStoryItemName;
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'teaser - embedded video',
            'component.LabelEvent': 'stories',
            'component.ActionEvent': 'click',
            'component.PositionEvent': activePromoName,
            'component.LocationEvent': activePromoStoryName,
            'component.EventDetails': 'custom cta',
            'component.URLClicked': 'not applicable',
        });
    }
    launchGame() {
        const gameInfo: any = this.gameManagerService.getGameInfo(this.gameId);
        const isTouch = this.casinoManager.isTouch();
        if (gameInfo) {
            gameInfo.gameId = this.gameId;
            const gameModel = new GameLaunch();
            gameModel.game = gameInfo;
            gameModel.isTouch = isTouch;
            gameModel.gamePosition = 1;
            gameModel.categoryType = 'GamingStories';
            gameModel.from = 'q';
            gameModel.replaceRouteInHistory = false;
            gameModel.isDemoLaunch = false;
            gameModel.skipUnfinGame = false;
            gameModel.gameLaunchedFrom = 'GamingStories';
            gameModel.gridPosition = 1;
            gameModel.gameContainer = 'GamingStories';
            gameModel.game.lobbyType = '';
            gameModel.clickTimeStamp = this.gameLaunchService.currentTimeStamp();
            this.gameLaunchService.launchGame(gameModel);
        }
    }
}
